import React, { lazy } from "react";
import { withTranslation } from "react-i18next";
const JourneyWeb = lazy(() => import("./WebComponents/JourneyWeb"));
const JourneyMobile = lazy(() =>
  import("./MobileComponents/JourneyMobile")
);

const JourneyComponent = ({t}) => {
 
  return (
    <>
      <JourneyWeb title={t("journeyComponent.title")} display={{ xs: "none", md: "flex" }} />
      <JourneyMobile title={t("journeyComponent.title")}  display={{ xs: "flex", md: "none" }} />
    </>
  );
};
export default withTranslation()(JourneyComponent);
